var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"div-height"},[_c('div',[_vm._v(" @2019 大连海大智龙科技有限公司")]),_vm._v(" "),_c('div',{staticClass:"span-top"},[_c('a',{attrs:{"href":"http://www.beian.miit.gov.cn"}},[_vm._v("辽ICP备19005184号")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a68e461","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commoncoms/footer.vue
// module id = null
// module chunks = 